import { useMutation } from 'react-query';

import { setPrivacyMode as mutationFn } from 'api/endPoints/setPrivacyMode';

export const useMutationSetPrivacyMode = () => {
    return useMutation<unknown, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

export interface QueryParams {
    viewId: number;
    isPublic: boolean;
}
